import { getAxios } from '@parchment/oauth2-axios';
import { GET_UI_CONFIG_START, GET_UI_CONFIG_DONE, GET_UI_CONFIG_ERROR } from './index';
import { CREDENTIAL_ACCOUNT_RESOURCE_KEY } from '../utils';

export function getUiConfig(evidenceType) {
    const url = '/ui-config/search', params = { params: { feature: evidenceType } };

    return (dispatch) => {
        dispatch({
            type: GET_UI_CONFIG_START
        });

        return getAxios(CREDENTIAL_ACCOUNT_RESOURCE_KEY).get(url, params).then((response) => {
            dispatch({
                type: GET_UI_CONFIG_DONE,
                payload: response
            });
        }).catch((error) => {
            dispatch({
                type: GET_UI_CONFIG_ERROR,
                payload: error.response
            });
        });
    };
}

